import restangular from "restangular";
export default "restangular";



// WEBPACK FOOTER //
// ./src/ui/app/services/restangular.js